export default __webpack_public_path__ + "static/media/binket.b1790526.png";